<div class="row">
    <div class="col-lg-6 col-md-12" [ngClass]="{'disabled': control && control.disabled}">
        <mat-form-field
                [ngClass]="{'outline': outlined}"
                [floatLabel]="outlined ? 'always' : !asFormsControl().floatingLabelNever ? 'auto' : 'never'"
                class="app-datepicker"
        >
            <input
                    matInput
                    #datepickerInput
                    readonly
                    [disabled]="asFormsControl().disabled"
                    [matDatepicker]="datepicker"
                    [placeholder]="asFormsControl().placeholder"
                    [min]="asFormsControl().minDate"
                    [max]="asFormsControl().maxDate"
                    (click)="openDatepicker(datepicker)"
                    (dateChange)="changeValue($event)"
            >
            <mat-datepicker-toggle
                    matSuffix
                    [for]="datepicker"
            ></mat-datepicker-toggle>

            <mat-datepicker
                #datepicker
                [disabled]="asFormsControl().disabled"
                (opened)="onTouched && onTouched()"
            ></mat-datepicker>
        </mat-form-field>
    </div>
    <div class="col-md-6 mb-3">
        <app-slide-toggle
                [checked]="asFormsControl().disabled"
                [texts]="getTexts()"
                (changed)="onSlideToggleChange($event)"
        ></app-slide-toggle>
    </div>
</div>
<div class="row">
    <div class="col-md-6">
        <div
                *ngIf='asFormsControl().errors.length > 0'
                class="form-text text-danger"
        >
            <span *ngFor="let error of asFormsControl().errors">{{error}}</span>
        </div>
    </div>
</div>